import React, { useEffect, useRef, useState } from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import Icon from 'components/Icon';
import TeaserPhoto from 'components/TeaserPhoto';
import { Button } from 'components/Button';
import './index.sass';
import ShortMobileFixedSpecialistTeaser from 'components/SpecialistTeaser/FixedSpecialistTeaser/MobileFixedSpecialistTeaser/ShortMobileFixedSpecialistTeaser';
import Model from '../../../../../model';

const { block, el } = bem('mobile-fixed-specialist-teaser');

const MobileFixedSpecialistTeaser = ({ specialist }) => {
    const ref = useRef(null);
    const [sticky, setSticky] = useState(false);

    const handleIntersection = (e) => {
        setSticky(!e[0].isIntersecting);
    }

    useEffect(() => {
        const io = new IntersectionObserver(handleIntersection, { rootMargin: '-64px 0px 0px 0px'});
        if (ref.current) {
            io.observe(ref.current)
        }

        return () => {
            io.disconnect();
        }
    }, [ref.current]);

    useEffect(() => {
        const header = document.querySelector('.mobile-fixed-header')
        if (header) {
            header.classList.toggle('specialist-teaser-sticky', sticky);
        }
    }, [sticky])

    const { name, specialisation, direction, length, id } = specialist.data;
    const { price } = specialist.data.servicesSet[0];
    const { city, experience, workingWithPairs, photo } = specialist;

    const { openSpecialistOrderForm } = Model.modal;
    const onClick = (e) => {
        e.preventDefault();
        openSpecialistOrderForm(specialist.id);
    }

    return (
        <div className={block()} ref={ref}>
            <ShortMobileFixedSpecialistTeaser sticky={sticky} name={name} id={id} photo={photo} onClick={onClick} />
            <div className={el('photo')}>
                <TeaserPhoto src={photo} alt={`Фото специалиста ${name}`} />
            </div>
            <div className={el('content')}>
                <div className={el('top-block')}>
                    <div className={el('caption')}>
                        <div className={el('experience')}>
                            <Icon name={'crown-simple'} />
                            <Text>{experience}</Text>
                        </div>
                        { city && <div className={el('location')}>
                            <Icon name={'navigation-arrow'} />
                            <Text>{city}</Text>
                        </div> }
                    </div>
                    <div className={el('name')}><Text serif={true} dangerouslySetInnerHTML={{__html: name}} /></div>
                    <div className={el('speciality')}><Text>{specialisation}</Text></div>
                </div>
                <div className={el('separator')} />
                <div className={el('bottom-block')}>
                    <div className={el('price-block')}>
                        <div className={el('price-label')}>
                            <Text>Стоимость</Text>
                        </div>
                        <div className={el('prices-list')}>
                            <div className={el('price-single')}>
                                <Icon name={'user'} />
                                <Text className={el('price')}>{`${price} ₽`}</Text>
                                <Text className={el('duration')}>{` ${length} мин`}</Text>
                            </div>
                            <div className={el('price-pair')}>
                                <Icon name={'users'} />
                                <Text className={el('price')}>{workingWithPairs ? `${price} ₽` : '-'}</Text>
                                { workingWithPairs && <Text className={el('duration')}>{` ${ length } мин`}</Text> }
                            </div>
                        </div>
                    </div>
                    <div className={el('button')}>
                        <Button mod={'transparent-gold'} onClick={onClick}><Text>Записаться к специалисту</Text></Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MobileFixedSpecialistTeaser;
